import PropTypes from 'prop-types';
import React from 'react';
import StockOrb from './StockOrb';
import styled from 'react-emotion';
import ChannelContext from '@jetshop/core/components/ChannelContext';

const StockContainer = styled('div')`
  display: flex;
  justify-content: space-between;
  align-items: center;
  width: 100%;
  margin-top: 1.5rem;
`;

const StatusText = styled('span')`
  display: inline-block;
  margin-left: 12px;
`;

const KlarnaImage = styled('img')`
  display: block;
  max-width: 78px;
`;

const StockStatusIndicator = ({ status, text }) => {
  return (
    <StockContainer>
      <ChannelContext.Consumer>
        {({ channels, selectedChannel, updateChannel }) => (
          <KlarnaImage
            src={`${
              channels[0].url
            }/pub_docs/files/Custom_Item_Images/Material/LogoKlarna.jpg`}
            alt={'Klarna Checkout'}
          />
        )}
      </ChannelContext.Consumer>
      <p>
        <StockOrb status={status} badge={false} />
        <StatusText>{text}</StatusText>
      </p>
    </StockContainer>
  );
};

StockStatusIndicator.propTypes = {
  status: PropTypes.oneOf(['inStock', 'outOfStock', 'notifyWhenBack']),
  text: PropTypes.string
};

export default StockStatusIndicator;
